 import React from 'react';

/**
 * Composant SEO réutilisable
 * Gère les meta tags, Open Graph et Twitter Cards.
 *
 * React 19 hisse nativement <title>, <meta> et <link> dans le <head>,
 * quel que soit l'endroit de l'arbre où ils sont rendus. Aucune
 * bibliothèque n'est nécessaire : react-helmet-async 2.0.5-next ne
 * supportait pas React 19 et ne produisait plus aucune balise.
 */
const SEO = ({
  title = 'Bouhdel - Votre projet est le nôtre',
  description = 'Constructeur de maisons individuelles sur mesure dans le sud de la France. Arles, Nîmes, Avignon. Expertise depuis plus de 20 ans.',
  author = 'Bouhdel',
  url = 'https://www.bouhdel.com/',
  // Photo drone 2048x1152 réellement présente dans public/. À remplacer par un
  // visuel dédié 1200x630 (texte + logo) dès qu'il existe.
  image = 'https://www.bouhdel.com/assets/og/bouhdel-og.jpg',
  type = 'website',
  twitterCard = 'summary_large_image',
  locale = 'fr_FR',
  siteName = 'Bouhdel',
  robots = 'index, follow',
  canonical = null,
}) => {
  // Origine nue -> forme avec slash final, pour coller au sitemap.
  const pageUrl = (canonical || url).replace(/^(https?:\/\/[^/]+)$/, '$1/');

  return (
    <>
      {/* Balises Meta de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {/* TODO vérifier que @bouhdel existe vraiment : un handle mort = signal de confiance perdu. */}
      <meta name="twitter:creator" content="@bouhdel" />

      {/* Balises additionnelles pour SEO local */}
      <meta name="geo.region" content="FR-30" />
      <meta name="geo.placename" content="Nîmes, Arles, Avignon" />
      <meta name="geo.position" content="43.8367;4.3601" />
      <meta name="ICBM" content="43.8367, 4.3601" />

      {/* lang est posé une fois pour toutes dans public/index.html */}
    </>
  );
};

export default SEO;
